/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The reseller's API account, if one exists.
 * @export
 * @interface ListResellers200ResponseInnerApiAccount
 */
export interface ListResellers200ResponseInnerApiAccount {
    /**
     * 
     */
    accountId: string;
    /**
     * OAuth client_id for the client credentials grant.
     */
    clientId: string;
    /**
     * 
     */
    createdAt: string;
}

/**
 * Check if a given object implements the ListResellers200ResponseInnerApiAccount interface.
 */
export function instanceOfListResellers200ResponseInnerApiAccount(value: object): value is ListResellers200ResponseInnerApiAccount {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ListResellers200ResponseInnerApiAccountFromJSON(json: any): ListResellers200ResponseInnerApiAccount {
    return ListResellers200ResponseInnerApiAccountFromJSONTyped(json, false);
}

export function ListResellers200ResponseInnerApiAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListResellers200ResponseInnerApiAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'clientId': json['clientId'],
        'createdAt': json['createdAt'],
    };
}

export function ListResellers200ResponseInnerApiAccountToJSON(json: any): ListResellers200ResponseInnerApiAccount {
    return ListResellers200ResponseInnerApiAccountToJSONTyped(json, false);
}

export function ListResellers200ResponseInnerApiAccountToJSONTyped(value?: ListResellers200ResponseInnerApiAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'clientId': value['clientId'],
        'createdAt': value['createdAt'],
    };
}

